import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import About from './pages/About';
import Resume from './pages/Resume';
import Education from './pages/Education';
import Projects from './pages/Projects';
import Achievements from './pages/Achievements';
import Competitions from './pages/Competitions';
import Leadership from './pages/Leadership';
import Certificates from './pages/Certificates';
import Skills from './pages/Skills';
import Contact from './pages/Contact';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"             element={<Hero />} />
        <Route path="/about"        element={<About />} />
        <Route path="/resume"       element={<Resume />} />
        <Route path="/education"    element={<Education />} />
        <Route path="/projects"     element={<Projects />} />
        <Route path="/achievements" element={<Achievements />} />
        <Route path="/competitions" element={<Competitions />} />
        <Route path="/leadership"   element={<Leadership />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/skills"       element={<Skills />} />
        <Route path="/contact"      element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}
